import React from 'react';
import propTypes from 'prop-types';

import { formatCurrency } from '../../../utilities/financing';

const AddonSplitfitmentQuantity = ({
  qtyRear,
  qtyFront,
  frontPrice,
  rearPrice,
}) => (
  <>
    <div className="cmp-quote-option__quantity-details">
      <h4>Front Tire</h4>
      <ul>
        <li>
          Quantity:
          {' '}
          {qtyFront}
        </li>
        <li>
          Unit Price:
          {' '}
          {formatCurrency(frontPrice)}
        </li>
      </ul>
    </div>
    <div className="cmp-quote-option__quantity-details">
      <h4>Rear Tire</h4>
      <ul>
        <li>
          Quantity:
          {' '}
          {qtyRear}
        </li>
        <li>
          Unit Price:
          {' '}
          {formatCurrency(rearPrice)}
        </li>
      </ul>
    </div>
  </>
);

AddonSplitfitmentQuantity.propTypes = {
  qtyFront: propTypes.number,
  qtyRear: propTypes.number,
  frontPrice: propTypes.number,
  rearPrice: propTypes.number,
};

export { AddonSplitfitmentQuantity };
